import Command from "@ckeditor/ckeditor5-core/src/command";
import { SCHEMA_NAME } from "./constant";

export default class VariableCommand extends Command {
  refresh() {
    const model = this.editor.model;
    const doc = model.document;

    // 将链接关联到到 value
    //this.value = doc.selection.getAttribute(SCHEMA_NAME);
    // 根据 editing.js 中定义的 schema 规则来维护按钮的禁用/启用状态
    this.isEnabled = true;
    //this.isEnabled = true;
  }

  execute(msgUse,baseDescription,probableType,detailsType,varCode,dataType,dataFilter,color,fontWeight) {
    //this.isEnabled = false;
    const model = this.editor.model;
    model.change((writer)=>{
      //  const selection = editor.model.document.selection;
      //  editor.model.insertContent(
      //   // Create a text node with the abbreviation attribute.
      //   writer.createText( variableStr, { flowVariable:variableStr,isBlock :true} )
      //   );
      const element = writer.createElement(SCHEMA_NAME, {
        value:msgUse,
        "data-base":msgUse,
        "data-title":baseDescription,
        "data-probable":probableType,
        "data-details":detailsType,
        "data-varcode":varCode,
        "data-type":dataType,
        "data-filter":dataFilter,
        "color":color,
        "font-weight":fontWeight
      });
      model.insertContent(element);
    });
  }
}